import styled from "styled-components";
import { breakpoint } from "@utilities";
import FooterTag from "./FooterTag";
import { selectSavedCarts, useAppSelector } from "@redux";
export interface ITag {
    Icon?: string;
    IconDark?: string; // Change from component type to string
    text: string;
    link: string;
    active?: boolean;
}
interface IFooterProps {
    tagList?: ITag[];
}
export const FooterMobileComponent = (props: IFooterProps) => {
    const isShowBtn = useAppSelector(selectSavedCarts).isShowPopup;
    return !isShowBtn ? (
        <StyledFooter>
            {props.tagList &&
                props.tagList.map((tag, index) => (
                    <FooterTag
                        key={index}
                        Icon={tag.Icon}
                        IconDark={tag.IconDark}
                        text={tag.text}
                        link={tag.link}
                        active={tag.active}
                    />
                ))}
        </StyledFooter>
    ) : (
        <></>
    );
};
const StyledFooter = styled.div`
    position: fixed;
    bottom: 0;
    height: 60px;
    display: flex;
    justify-content: center;
    width: 100vw;
    background-color: #fff;
    z-index: 2;
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.1);
    ${breakpoint.breakTablet`
        display: none;
    `}
`;
